import type { OrgSpecificContentsPayload } from "@/org-specific-contents/types";

export const parseOrgSpecificContents = (
  raw: string | undefined
): OrgSpecificContentsPayload | null => {
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as OrgSpecificContentsPayload;
  } catch (exception) {
    console.warn(
      "[OrgSpecificContents] Invalid org-specific contents JSON – privacy policy URL disabled.",
      exception
    );
    return null;
  }
};

export const buildPrivacyPolicyUrl = (payload: OrgSpecificContentsPayload | null): string =>
  payload?.PRIVACY_POLICY_URL?.trim() ?? "";
